export default __webpack_public_path__ + "static/media/lake.cd37fdfc.png";